<div class="detail-header-container">
    <mat-panel-title (click)="$event.stopPropagation()">
        @if (formMode === FormMode.Creation) {
            <p class="title">Création</p>
        }
        @if (formMode !== FormMode.Creation) {
            <p class="title" matTooltip="{{ displayName + ' (' + id + ')' }}" matTooltipPosition="below">{{ displayName }}</p>
        }
    </mat-panel-title>
    <mat-panel-description (click)="$event.stopPropagation()">
        <button mat-fab class="basic-button management-button" (click)="$event.stopPropagation(); onBackToList()" matTooltip="Retourner à la liste">
            <fa-icon [icon]="faList"></fa-icon>
        </button>
        @if (editRight === true) {
            <mat-button-toggle-group
                name="mode"
                aria-label="Mode de visualisation"
                [value]="formMode === FormMode.Reading ? 'reading' : 'editing'"
                (change)="onModeChange($event)"
                class="basic-button">
                <mat-button-toggle class="basic-button" value="reading" [matTooltip]="formMode === FormMode.Reading ? 'Mode consultation activé' : 'Activer le mode consultation'">
                    <fa-icon [icon]="faEye"></fa-icon>
                </mat-button-toggle>
                <mat-button-toggle class="basic-button" value="editing" [matTooltip]="formMode !== FormMode.Reading ? 'Mode édition activé' : 'Activer le mode édition'">
                    <fa-icon [icon]="faEdit"></fa-icon>
                </mat-button-toggle>
            </mat-button-toggle-group>
        }
        <button mat-fab class="basic-button management-button" (click)="$event.stopPropagation(); onHelp()" matTooltip="Afficher l'aide">
            <fa-icon [icon]="faQuestion"></fa-icon>
        </button>
    </mat-panel-description>
</div>
